import { injectGlobal } from 'styled-components'

injectGlobal`
  ion-icon {
    font-size: 24px;
  }

  ion-icon.small {
    font-size: 16px;
  }
`



// WEBPACK FOOTER //
// ./src/styles/icons.js